import Vue from 'vue'
import { $$ } from '../_utils'
import EventBus from '../_event-bus'

Vue.component('vue-my-account-main', {
  template: '#vue-my-account-main-template',
  props: { breakpoint: Number, orders: Array },
  data() {
    return {
      layout: '',
    }
  },
  methods: {
    addResizeListener() {
      EventBus.$on('resize', this.setLayout)
    },
    getViewportWidth() {
      return window.innerWidth
    },
    setLayout() {
      this.layout = this.getViewportWidth() <= this.$props.breakpoint ? 'mobile' : 'desktop'
    },
  },
  mounted() {
    this.setLayout()
    this.addResizeListener()
  },
})

const mains = $$('#vue-my-acccount-main-wrapper')
window.addEventListener('DOMContentLoaded', () => {
  if (!mains) return
  mains.forEach(element => {
    new Vue({
      el: element,
    })
  })
})
